module.exports = __webpack_public_path__ + "static/media/down-arrow.f5b5e457.svg";